import { put, takeLatest, select } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';
import _ from 'lodash';

const getCurrentCenterId = state => state.identity.centerId;

function * getGalleryInformation (payload) {
  try {
    const centerId = yield select(getCurrentCenterId);
    const response = yield ktRequest.get(`gallery/center/${centerId}`, 'gallery');
    const { data } = response;
    const groupedByRoomId = _.groupBy(data, 'room_id');
    const sorted = {};

    // default sort by number of photos taken today
    Object.keys(groupedByRoomId).forEach(key => {
      const value = groupedByRoomId[key];
      const sortedArray = _.sortBy(value, [child => parseInt(child.numberOfPhotosTakenToday, 10)]);

      sorted[key] = sortedArray;
    });

    yield put(actions.getRoomGallerySuccess(sorted));
  } catch (error) {
    console.log(error);
    yield put(actions.getRoomGalleryFailure());
  }
}

export const roomGallerySagas = [
  takeLatest(types.GET_ROOM_GALLERY_REQUEST, getGalleryInformation)
];
